<template>
  <div class="content">
    <AppHeader @fetchData="getInit" />
    <div class="banner">
      <swiper
        :options="swiperOption"
        ref="mySwiperOne"
        class="OneSwiper"
        v-if="bannerlist.length"
      >
        <swiper-slide class="appsolon" v-for="(item, x) in bannerlist" :key="x">
          <img :src="item.imgCont" :data-item="2000" />
        </swiper-slide>
      </swiper>

      <div class="notice">
        <div class="notice_inner">
          <span class="notice_name">公告</span>
          <span class="title" v-if="noticeList.length">{{
            noticeList[0].title
          }}</span>
          <div
            class="arrow-right"
            @click="toPage('/notice', noticeColumnId)"
          ></div>
        </div>
      </div>
    </div>
    <div class="sign_up padding_con">
      <div
        v-for="(item, index) in signList"
        @click="toSignUp(item.path, index)"
        :key="index"
        class="sign_up_item"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="content_item padding_con">
      <div class="title">
        <div class="title_l">年度活动<span>Annual Events</span></div>
        <div class="title_r" @click="toPage('/theme', thememColumnId)">
          MORE
        </div>
      </div>
      <div class="activity_con">
        <swiper
          :options="swiperOptionOne"
          ref="mySwiperOne"
          class="OneSwiper"
          v-if="activityList.length"
        >
          <swiper-slide
            class="activity_slide"
            v-for="(act, x) in activityList"
            :key="x"
            @click="toPage2(act)"
          >
            <div class="activity_item" v-if="act.cover_img">
              <img :src="act.cover_img" />
              <div class="act_title">{{ act.name }}</div>
            </div>
          </swiper-slide>
          <div class="swiper-footer" slot="pagination">
            <div class="swiper-paginationOne"></div>
            <div class="swiper-scrollbar"></div>
          </div>
        </swiper>
      </div>
    </div>
    <div class="content_item">
      <div class="news_con_t padding_con">
        <div class="title">
          <div class="title_l">新闻资讯<span>News</span></div>
        </div>
        <div class="news_con">
          <swiper
            :options="swiperOptionTwo"
            ref="mySwiperTwo"
            class="TwoSwiper"
            v-if="newlist.length"
          >
            <swiper-slide
              class="news_slide"
              v-for="(item, x) in newlist"
              :key="x"
            >
              <div class="news_item">
                <img :src="item.coverImg" />
                <div class="new_title">
                  <div class="new_title_in">
                    <div class="new_title_l">{{ item.title }}</div>
                    <div class="swiper-paginationTwo" slot="pagination"></div>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
          </swiper>
        </div>
      </div>
      <div class="news_con_d padding_con">
        <div
          class="news_list"
          v-for="(item, x) in newlist.slice(0, 4)"
          :key="x"
          @click="toDetail(item, '/newsDetail')"
        >
          <div class="list_l">
            <span class="day" v-if="item.publishTime">{{
              item.publishTime.slice(8, 10)
            }}</span>
            <span class="month" v-if="item.publishTime"
              >/{{ item.publishTime.slice(5, 7) }}月</span
            >
          </div>
          <div class="list_r">{{ item.title }}</div>
        </div>
        <div class="more" @click="toPage('/news', newColumnId)">MORE</div>
      </div>
    </div>
    <div class="content_item">
      <div class="padding_con">
        <div class="title">
          <div class="title_l">年度主题<span>Theme</span></div>
        </div>
      </div>
      <div class="theme_con" @click="toPage2(themeInfo)">
        <div class="theme_con_img">
          <img :src="themeInfo.cover_img" />
        </div>
        <!-- <div class="theme_con_l">
          <div class="theme_title">{{ themeInfo.title }}</div>
          <div><img :src="themeInfo.cover_img" /></div>
          <div class="theme_eng">{{ themeInfo.sTitle }}</div>
        </div>
        <div class="theme_con_r">
          <div class="time">
            {{ themeInfo.year }} <strong>{{ themeInfo.themeTime }}</strong>
          </div>
          <div class="desc">
            {{ themeInfo.msg }}
          </div>
        </div> -->
      </div>
    </div>
    <div class="content_item">
      <div class="padding_con">
        <div class="title">
          <div class="title_l">演出时间表<span>Time</span></div>
          <div class="title_r">MORE</div>
        </div>
      </div>
      <div class="activity_Time_con padding_con">
        <DateTab v-model="currentDay" :date-list="dateList" @change="getData" />
        <!-- <div class="calendar">
          <div
            :class="['calendarList', currentDay == cal.date ? 'active' : '']"
            v-for="(cal, index) in dateList.slice(0, 5)"
            :key="index"
            @click="getData(cal, index)"
          >
            <div class="date">{{ cal.date.slice(5, 10) }}</div>
            <div class="week">{{ cal.shortWeekday }}</div>
          </div>
          <div @click="showDatePicker" class="more">更多</div>
          <date-picker ref="datePicker" @confirm="confirm"></date-picker>
        </div> -->
        <div class="activity_Time_list">
          <div class="Time_list_top">
            <div class="title_l">
              <div class="title_l_in">
                <span class="month">{{ currentDay.slice(5, 7) }}/</span>
                <span class="day">{{ currentDay.slice(8, 10) }}</span>
              </div>
            </div>
            <div class="title_r">乌镇戏剧节活动一览表</div>
          </div>
          <div v-if="activityTimeList.length">
            <div class="Time_list_down">
              <div v-html="activityTimeList[0].details.content"></div>
              <!-- <ul>
              <li>
                <div class="time">时间</div>
                <div class="name">剧目</div>
              </li>
              <li v-for="(activity, index) in activityTimeList" :key="index">
                <div class="time">{{ activity.time }}</div>
                <div class="name">{{ activity.name }}</div>
              </li>
            </ul> -->
            </div>
          </div>
          <div class="content_top" v-else>
            <el-empty :description="$t('noData')"></el-empty>
          </div>
        </div>
      </div>
    </div>
    <div class="content_item">
      <div class="padding_con">
        <div class="title">
          <div class="title_l">
            乌镇戏剧节主席团<span>Chairman's Committee</span>
          </div>
        </div>
      </div>
      <div
        class="presi_con padding_con"
        style="position: relative; padding-bottom: 4.1667rem"
      >
        <div
          class="presi_character"
          v-for="(chara, index) in presiList"
          :key="index"
          @click="toDetail(chara, '/presidiumDetail')"
        >
          <div class="presi_img"><img :src="chara.coverImg" /></div>
          <div class="presi_content">
            <p class="presi_title">{{ chara.title }}</p>
            <p class="presi_actor" v-if="chara.details">
              {{ chara.details.shortTitle }}
            </p>
            <p class="presi_actor" v-if="chara.details">
              {{ chara.details.digest }}
            </p>
          </div>
        </div>
        <div class="more" @click="toPage('/presidium', presiColumnId)">
          MORE
        </div>
      </div>
    </div>
    <div class="content_item">
      <div class="padding_con">
        <div class="title">
          <div class="title_l">精彩视频<span>Videos</span></div>
          <div class="title_r" @click="toPage('/videoList', videoColumnId)">
            MORE
          </div>
        </div>
      </div>
      <div class="video_con">
        <swiper
          :options="swiperOptionThree"
          ref="mySwiperThree"
          class="ThreeSwiper"
          v-if="videoList.length"
        >
          <swiper-slide
            class="video_slide"
            v-for="(act, index) in videoList"
            :key="index"
          >
            <div
              class="video_item"
              @click="toggleVideo(index)"
              @touchstart="showPlayIcon(index)"
              @touchend="hidePlayIcon(index)"
            >
              <img
                class="video_item_default"
                v-if="act.coverImg && !isVideoPlaying[index]"
                :src="act.coverImg"
              />
              <img
                class="video_item_default"
                v-if="!act.coverImg && !isVideoPlaying[index]"
                :src="videoDefault"
              />
              <video
                v-show="isVideoPlaying[index]"
                style="width: 27.25rem; height: 15.3333rem"
                :ref="'mainVideo-' + index"
                @play="pauseOtherVideos(index)"
                @ended="handleVideoEnded(index)"
              >
                <source :src="act.videoUrl" type="video/mp4" />
              </video>
              <div class="video_title">{{ act.title }}</div>
              <div
                v-if="!isVideoPlaying[index]"
                class="play_con"
                @click="pauseOtherVideos(index)"
              >
                <img src="../assets/img/play_icon.png" />
              </div>
              <div
                v-if="isVideoPlaying[index] && isHovering[index]"
                class="play_con"
                @click="pauseOtherVideos(index)"
              >
                <img src="../assets/img/play_icon2.png" />
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-paginationThree" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <!-- <div class="content_item padding_con">
      <div class="title">
        <div class="title_l">合作伙伴<span>Partner</span></div>
        <div class="title_r" @click="toPage('/partner')">MORE</div>
      </div>

      <div class="link_con">
        <div class="link_item" v-for="(l, index) in friendLink" :key="index">
          <img v-if="l.coverImg" :src="l.coverImg" />
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import AppHeader from '@/components/AppHeader';
import datePicker from '@/components/date-picker.vue';
import {
  getWeekDates,
  formatDateToYMD,
  getDatetime,
  getDateRange,
} from '@/utils/date.js';
import DateTab from '@/components/DateTab';
import i18n from '@/i18n';
import {
  fetchBanner,
  fetchConentList,
  fetchCmsColumnList,
  getPageObj,
} from '@/assets/api';
import { themeTab } from '@/const';
export default {
  name: 'appHome',
  components: { swiper, swiperSlide, datePicker, AppHeader, DateTab },
  data() {
    return {
      bannerlist: [],
      signUplist: [],
      swiperOption: {
        // direction:"horizontal",/*横向滑动*/
        spaceBetween: 0,
        //可见图片张数
        slidesPerView: 1,
        // loopedSlides: 4,// 在loop模式下使用slidesPerView，还需使用该参数设置所要用到的loop个数(一般设置大于可视slide个数2个即可)
        loopFillGroupWithBlank: true,
        observer: true, // 改变swiper样式时，自动初始化swiper
        observeParents: true, // 监测swiper父元素，如果有变化则初始化swiper
        autoplayDisableOnInteraction: false,
        paginationClickable: true,
        // 默认选中中间一张
        centeredSlides: true,
        // preventClicks: false,//当swiper在触摸时阻止默认事件（preventDefault），用于防止触摸时触发链接跳转。
        //无限循环
        loop: true,

        //自动轮播
        autoplay: true,
        on: {
          // init: function () {
          //   if (this.bannerlist.length <= 1) {
          //     this.disable(); // 禁用滑动
          //   }
          // },
        },
      },
      noticeList: [
        // {
        //   title: '乌镇戏剧节关于某某某某某某某某事情的公告',
        //   time: '2025-05-31',
        // },
        // {
        //   title: '乌镇戏剧节关于某某某某某某某某事情的公告',
        //   time: '2025-05-31',
        // },
      ],
      signList: [
        {
          name: i18n.t('youthRregist'),
          value: 0,
          path: 'http://www.wuzhenfestival.com/index.php?m=Member&a=login',
        },
        {
          name: i18n.t('carnivalRregist'),
          value: 1,
          path: 'http://www.wuzhenfestival.com/index.php?m=Member&a=login',
        },
        { name: i18n.t('mediaRegist'), value: 2, path: '/mediaRegist' },
      ],
      cloumnList: [],
      swiperOptionOne: {
        // direction:"horizontal",/*横向滑动*/
        spaceBetween: 0,
        //可见图片张数
        slidesPerView: 3.4, // 显示3张完整图片+第4张的20%
        // 在loop模式下使用slidesPerView，还需使用该参数设置所要用到的loop个数(一般设置大于可视slide个数2个即可)
        loopFillGroupWithBlank: true,
        observer: true, // 改变swiper样式时，自动初始化swiper
        observeParents: true, // 监测swiper父元素，如果有变化则初始化swiper
        autoplayDisableOnInteraction: false,
        paginationClickable: true,
        // 默认选中中间一张
        centeredSlides: true,
        // preventClicks: false,//当swiper在触摸时阻止默认事件（preventDefault），用于防止触摸时触发链接跳转。
        //无限循环
        loop: true,

        // pagination: false, // 明确禁用分页器

        //自动轮播
        autoplay: false,

        // pagination:'.swiper-pagination',
        //小圆点（我此处没使用，列出供参考）
        pagination: {
          el: '.swiper-paginationOne',
          type: 'fraction', // 设置为分数形式
          formatFractionCurrent: function (number) {
            return number; // 当前页码
          },
          formatFractionTotal: function (number) {
            return number; // 总页数
          },
        },
        // 滚动条设置 (作为进度条)
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: false, // 不自动隐藏
          draggable: true, // 可拖动
        },
      },
      activityList: [
        // {
        //   title: '特邀剧目',
        //   eng: 'Specially invited plays',
        //   desc: '第十一届乌镇戏剧节特邀剧目包括【璀璨国际】【剧场英姿】【纵横天下】【新锐光芒】【舞之剧场】【学院观察】【没有不可能】七大板块。',
        //   img: require('../assets/img/activity_img1.png'),
        // },
      ],
      swiperOptionTwo: {
        // direction:"horizontal",/*横向滑动*/
        spaceBetween: 0,
        //可见图片张数
        slidesPerView: 1,
        // loopedSlides: 4,// 在loop模式下使用slidesPerView，还需使用该参数设置所要用到的loop个数(一般设置大于可视slide个数2个即可)
        loopFillGroupWithBlank: true,
        observer: true, // 改变swiper样式时，自动初始化swiper
        observeParents: true, // 监测swiper父元素，如果有变化则初始化swiper
        autoplayDisableOnInteraction: false,
        paginationClickable: true,
        // 默认选中中间一张
        centeredSlides: true,
        // preventClicks: false,//当swiper在触摸时阻止默认事件（preventDefault），用于防止触摸时触发链接跳转。
        //无限循环
        loop: true,

        //自动轮播
        autoplay: true,

        // pagination:'.swiper-pagination',
        //小圆点（我此处没使用，列出供参考）
        pagination: {
          el: '.swiper-paginationTwo',
          clickable: true,
          type: 'bullets',
          //type : 'custom',
          renderBullet: function (index, className) {
            return '<div class="' + className + '"><span></span></div>';
          },
          // bulletElement: 'li',
        },
      },
      newlist: [
        // {
        //   title:
        //     '新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题新...',
        //   img: require('../assets/img/activity_img7.png'),
        //   time: '2025-06-01',
        // },
      ],
      themeInfo: {},
      show: false,
      dateList: [],
      currentDay: '',
      activityTimeList: [
        // { time: '16:00', name: '酒神' },
        // { time: '17:00', name: '躺平2.0' },
        // { time: '18:00', name: '酒神' },
        // { time: '19:00', name: '躺平2.0' },
        // { time: '20:00', name: '酒神' },
        // { time: '21:00', name: '躺平2.0' },
      ],
      presiList: [
        {
          img: require('../assets/img/presi_character1.png'),
          name: '陈向宏',
          promoter: true,
          actor: '乌镇戏剧节主席',
        },
        {
          img: require('../assets/img/presi_character1.png'),
          name: '陈向宏',
          promoter: true,
          actor: '乌镇戏剧节主席',
        },

        {
          img: require('../assets/img/presi_character1.png'),
          name: '陈向宏',
          promoter: true,
          actor: '乌镇戏剧节主席',
        },
        {
          img: require('../assets/img/presi_character1.png'),
          name: '陈向宏',
          promoter: true,
          actor: '乌镇戏剧节主席',
        },
        {
          img: require('../assets/img/presi_character1.png'),
          name: '陈向宏',
          promoter: false,
          actor: '乌镇戏剧节主席',
        },
        {
          img: require('../assets/img/presi_character1.png'),
          name: '陈向宏',
          promoter: false,
          actor: '乌镇戏剧节主席',
        },
      ],
      videoList: [
        // {
        //   title: '特邀剧目',
        //   eng: 'Specially invited plays',
        //   desc: '第十一届乌镇戏剧节特邀剧目包括【璀璨国际】【剧场英姿】【纵横天下】【新锐光芒】【舞之剧场】【学院观察】【没有不可能】七大板块。',
        //   img: require('../assets/img/activity_img1.png'),
        // },
      ],
      videoDefault: require('@/assets/img/video_default.png'),
      isVideoPlaying: [],
      isHovering: [],
      swiperOptionThree: {
        // direction:"horizontal",/*横向滑动*/
        spaceBetween: -15,
        //可见图片张数
        slidesPerView: 1.2, // 显示3张完整图片+第4张的20%
        // loopedSlides: 4,// 在loop模式下使用slidesPerView，还需使用该参数设置所要用到的loop个数(一般设置大于可视slide个数2个即可)
        loopFillGroupWithBlank: true,
        observer: true, // 改变swiper样式时，自动初始化swiper
        observeParents: true, // 监测swiper父元素，如果有变化则初始化swiper
        autoplayDisableOnInteraction: false,
        paginationClickable: true,
        effect: 'coverflow',

        coverflowEffect: {
          rotate: 0,
          stretch: -20, // 负值使两侧图片向内收缩
          depth: 150,
          modifier: 1.5, // 增强透视效果
          slideShadows: false,
        },
        // on: {
        //   init: function () {
        //     console.log(111, this.activeIndex, this.slides);
        //     this.slides.forEach((slide, index) => {
        //       if (index !== this.activeIndex) {
        //         slide.style.opacity = '0.5';
        //         slide.style.transform = 'scale(0.85)';
        //       }
        //     });
        //   },
        //   slideChange: function () {
        //     console.log(2, this.activeIndex);
        //     this.slides.forEach((slide, index) => {
        //       slide.style.opacity = index === this.activeIndex ? '1' : '0.5';
        //       slide.style.transform =
        //         index === this.activeIndex ? 'scale(1)' : 'scale(0.85)';
        //     });
        //   },
        // },
        // 默认选中中间一张
        centeredSlides: true,
        // preventClicks: false,//当swiper在触摸时阻止默认事件（preventDefault），用于防止触摸时触发链接跳转。
        //无限循环
        loop: true,

        //自动轮播
        autoplay: true,
        // pagination:'.swiper-pagination',
        //小圆点（我此处没使用，列出供参考）
        pagination: {
          el: '.swiper-paginationThree',
          type: 'bullets',
          formatFractionCurrent: function (number) {
            return number; // 当前页码
          },
          formatFractionTotal: function (number) {
            return number; // 总页数
          },
        },
      },
      activeVideoIndex: -1,
      friendLink: [
        { img: require('../assets/img/link1.png') },
        { img: require('../assets/img/link1.png') },
        { img: require('../assets/img/link1.png') },
        { img: require('../assets/img/link1.png') },
        { img: require('../assets/img/link1.png') },
        { img: require('../assets/img/link1.png') },
        { img: require('../assets/img/link1.png') },
        { img: require('../assets/img/link1.png') },
        { img: require('../assets/img/link1.png') },
      ],
      //栏目id
      thememColumnId: '',
      newColumnId: '',
      noticeColumnId: '',
      presiColumnId: '',
      videoColumnId: '',
    };
  },
  computed: {
    navTree() {
      return this.$store.state.navTree;
    },
  },
  watch: {
    navTree(newVal, oldVal) {
      this.getInit(newVal);
    },
  },
  mounted() {
    this.$store.dispatch('getSite').then((res) => {
      this.getInit(res);
      this.initShowTime();
    }); //获取站点和导航
  },
  methods: {
    initShowTime() {
      this.siteList = this.$store.state.siteList;
      this.siteValue = this.$store.state.siteValue;
      let siteName = '';

      this.siteList.map((s) => {
        if (s.id == this.siteValue) {
          siteName = s.keywords;
        }
      });
      const year = siteName && siteName.slice(0, 4);
      this.dateList = getDateRange(year);
      this.currentDay = this.dateList[0].date;
    },
    getInit(res) {
      this.cloumnList = res;
      this.getBanner();
      this.getNoticeList();
      this.annualAct();
      this.getNewsList();
      this.getPresList();
      this.getVideoList();
      this.getTheme();
      this.getParterList();
      this.getPerformList(); //演出
      this.getSignUp();

      this.signList = this.signList.map((s, index) => {
        if (index == 0) {
          s.name = this.$t('youthRregist');
          return s;
        } else if (index == 1) {
          s.name = this.$t('carnivalRregist');
          return s;
        } else if (index == 2) {
          s.name = this.$t('mediaRegist');
          return s;
        }
      });
    },
    // banner图
    getBanner() {
      let data = {
        current: 1,
        size: 999,
        state: 0,
        typeId: '1867105440813596674', //类型
        siteId: this.$store.state.siteValue,
      };
      fetchBanner(data).then((res) => {
        if (res.code == 200) {
          this.bannerlist = res.data.records;
          if (this.bannerlist.length > 1) {
            this.swiperOptionOne.autoplay = true;
          }
        }
      });
    },
    getSignUp() {
      let data = {
        current: 1,
        size: 999,
        state: 0,
        typeId: '1951525986393645057', //类型
        siteId: this.$store.state.siteValue,
      };
      fetchBanner(data).then((res) => {
        if (res.code == 200) {
          this.signUplist = res.data.records;
        }
      });
    },
    // 公告
    getNoticeList() {
      this.noticeColumnId = '';
      this.cloumnList.map((c) => {
        if (c.accessPath == '/news') {
          c.children.map((cl) => {
            if (cl.accessPath == '/notice') {
              this.noticeColumnId = cl.id;
            }
          });
        }
      });
      const data = {
        columnIds: this.noticeColumnId,
        size: 2,
        current: 1,
      };
      fetchConentList(data).then((res) => {
        this.noticeList = res.records;
      });
    },
    // 年度活动
    annualAct() {
      const ids = themeTab.tab;

      let parentId = '';
      this.cloumnList.map((c) => {
        if (c.accessPath == '/theme') {
          parentId = c.id;
        }
      });
      const data = {
        parentId: parentId,
        size: 999,
        current: 1,
      };
      fetchCmsColumnList(data).then((res) => {
        if (res.code == 200) {
          this.activityList = [];
          const data = res.data.records;
          ids.map((i, index) => {
            data.map((d) => {
              if (i.id == d.id) {
                this.activityList.push(d);
              }
            });
          });
          // this.$nextTick(() => {
          //   this.$refs.mySwiperOne.swiper.update(); // 强制更新 Swiper
          // });
        }
      });
    },
    // 新闻
    getNewsList() {
      this.newColumnId = '';
      this.cloumnList.map((c) => {
        if (c.accessPath == '/news') {
          c.children.map((cl) => {
            if (cl.accessPath == '/news') {
              this.newColumnId = cl.id;
            }
          });
        }
      });
      const data = {
        columnIds: this.newColumnId,
        size: 5,
        current: 1,
      };
      fetchConentList(data).then((res) => {
        this.newlist = res.records;
      });
    },

    // 主题
    getTheme() {
      this.thememColumnId = '';
      this.cloumnList.map((c) => {
        if (c.accessPath == '/theme') {
          c.children.map((cl) => {
            if (cl.accessPath == '/theme') {
              this.thememColumnId = cl.id;
            }
          });
        }
      });
      getPageObj(this.thememColumnId).then((res) => {
        if (res.code == 200) {
          this.themeInfo = res.data;
        }
      });
    },
    //主席团
    getPresList() {
      this.presiColumnId = '';
      this.cloumnList.map((c) => {
        if (c.accessPath == '/Introduction') {
          c.children.map((cl) => {
            if (cl.accessPath == '/presidium') {
              this.presiColumnId = cl.id;
            }
          });
        }
      });
      const data = {
        columnIds: this.presiColumnId,
        size: 6,
        current: 1,
      };
      fetchConentList(data).then((res) => {
        this.presiList = res.records;
      });
    },
    // 视频
    getVideoList() {
      this.videoColumnId = '';
      this.cloumnList.map((c) => {
        if (c.accessPath == '/videoList') {
          c.children.map((cl) => {
            if (cl.accessPath == '/videoList?type=2') {
              this.videoColumnId = cl.id;
            }
          });
        }
      });
      const data = {
        columnIds: this.videoColumnId,
        size: 999,
        current: 1,
      };
      fetchConentList(data).then((res) => {
        this.isVideoPlaying = [];
        this.isHovering = [];
        this.videoList = res.records.map((r, index) => {
          if (r.details) {
            r.videoUrl = r.details.cs;
          }
          this.$set(this.isVideoPlaying, index, false);
          this.$set(this.isHovering, index, false);
          return r;
        });
        if (this.videoList.length <= 1) {
          this.swiperOptionThree.autoplay = false;
          this.swiperOptionThree.loop = false;
        } else {
          this.swiperOptionThree.autoplay = true;
          this.swiperOptionThree.loop = true;
        }
      });
    },
    // 合作伙伴
    getParterList() {
      let id = '';
      this.cloumnList.map((c) => {
        if (c.accessPath == '/partner') {
          id = c.id;
        }
      });
      const data = {
        columnIds: id,
        size: 999,
        current: 1,
      };
      fetchConentList(data).then((res) => {
        this.friendLink = res.records;
      });
    },
    //演出时间表
    getPerformList(time) {
      let id = '';
      this.cloumnList.map((c) => {
        if (c.accessPath == '/theme') {
          c.children.map((cl) => {
            if (cl.accessPath == '/themeTime') {
              id = cl.id;
            }
          });
        }
      });
      const data = {
        columnIds: id,
        size: 6,
        current: 1,
        startTime: this.currentDay + ' 00:00:00',
        endTime: this.currentDay + ' 23:59:59',
      };
      fetchConentList(data).then((res) => {
        this.activityTimeList = res.records;
      });
    },
    // 点击切换播放/暂停
    toggleVideo(index) {
      this.isVideoPlaying[index] = !this.isVideoPlaying[index];
      const swiper = this.$refs.mySwiperThree?.swiper;
      const videoRef = this.$refs[`mainVideo-${index}`]?.[0];
      if (!videoRef || !swiper) return;

      if (videoRef.paused) {
        // 播放视频时停止 Swiper 轮播
        swiper.autoplay.stop();
        videoRef.play().catch((e) => console.error('播放失败:', e));
      } else {
        // 暂停视频时恢复 Swiper 轮播
        swiper.autoplay.start();
        videoRef.pause();
      }
      this.$forceUpdate();
    },
    handleVideoEnded(index) {
      this.activeVideoIndex = -1;
    },
    // 暂停其他视频
    pauseOtherVideos(currentIndex) {
      this.videoList.forEach((_, i) => {
        if (i !== currentIndex) {
          const video = this.$refs[`mainVideo-${i}`]?.[0];
          if (video) video.pause();
        }
      });
    },
    showPlayIcon(index) {
      this.$set(this.isHovering, index, true); // 使用 $set 确保响应式
    },

    // 鼠标移出隐藏图标
    hidePlayIcon(index) {
      this.$set(this.isHovering, index, false);
    },
    // 时间变化
    getData(time) {
      this.currentDay = time;
      this.getPerformList(time);
    },
    showDatePicker() {
      this.$refs.datePicker.open();
    },
    confirm(time) {
      this.currentDay = formatDateToYMD(time.date);
      this.dateList = getWeekDates(this.currentDay);
      this.getPerformList(this.currentDay);
      this.$refs.datePicker.cancle();
    },
    toPage(path, id) {
      this.$router.push({ path: path, query: { cloumnId: id } });
    },
    toPage2(item) {
      this.$router.push({
        path: item.accessPath,
        query: { cloumnId: item.id },
      });
    },
    toDetail(row, path) {
      this.$router.push({
        path: path,
        query: { cloumnId: row.columnId, id: row.id },
      });
    },
    toSignUp(path, index) {
      if (index == 2) {
        this.toPage(path);
      } else {
        const arr = this.signUplist.filter(
          (s) => !s.chaiAddress.includes('/mediaRegist')
        );
        arr.map((a) => {
          if (index == 1) {
            if (a.chaiAddress.includes('/Carnival')) {
              this.$router.push({ path: a.chaiAddress });
            }
          } else {
            window.location.href = a.chaiAddress;
          }
        });
        // window.location.href = arr[0].chaiAddress;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.padding_con {
  padding: 0 1.5rem;
}
.content {
  background: #f9f9f9;
  .banner {
    position: relative;
    .appsolon {
      height: 15.5rem;
      img {
        height: 100%;
        width: 100vw;
        object-fit: cover;
        object-position: center; /* 图片的中心与容器的中心对齐 */
      }
    }
  }
  .notice {
    position: absolute;
    bottom: 0;
    z-index: 3;
    height: 3rem;
    background: rgba(66, 68, 81, 0.75);
    width: 100vw;
    box-sizing: border-box;
    .notice_inner {
      display: flex;
      justify-content: space-between;
      width: 100vw;
      padding: 0 2rem;
      line-height: 3rem;
      align-items: center;
      .notice_name {
        background: linear-gradient(to bottom, #92a0ff, #87e0f0);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        font-size: 1.5rem;
        font-weight: bold;
        width: 3.75rem;
      }
      .title {
        font-size: 1.1667rem;
        color: #fff;
        text-align: left;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .arrow-right {
        width: 10px;
        height: 10px;
        background-color: transparent;
        border-color: #fff;
        border-style: solid;
        border-width: 2px 2px 0 0;
        transform: rotate(45deg);
      }
    }
  }
  .sign_up {
    display: flex;
    justify-content: space-between;
    padding-top: 2rem;
    .sign_up_item {
      height: 2.3333rem;
      width: 30%;
      padding: 0 1rem;
      border-radius: 1.75rem;
      box-sizing: border-box;
      text-align: center;
      color: #2a2a2a;
      font-family: sourcehansanscn-medium;
      font-size: 0.8333rem;
      line-height: 2.3333rem;
      background: rgba(218, 219, 223, 0.45);
      box-shadow: 4px 6px 16px 0px rgba(0, 0, 0, 0.12);
      position: relative;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      &::after {
        --mask-bg: linear-gradient(red, red);
        --mask-clip: content-box, padding-box;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 2.3333rem;
        width: 100%;
        border-radius: 1.75rem;
        padding: 2px 2px 2px 2px;
        box-sizing: border-box;
        background: linear-gradient(
          274deg,
          rgba(182, 182, 182, 0.5),
          rgba(255, 255, 255, 0.5),
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0.5),
          rgba(182, 182, 182, 0.5)
        );
        mask-composite: exclude;
        mask-clip: var(--mask-clip);
        mask-image: var(--mask-bg), var(--mask-bg);
        -webkit-mask-image: var(--mask-bg), var(--mask-bg);
        -webkit-mask-clip: var(--mask-clip);
        -webkit-mask-composite: destination-out;
      }
      &:hover {
        overflow: visible;
        text-overflow: clip;
        flex: 0 0 auto; // 不再压缩，宽度由内容撑开
        max-width: none; // 允许自动放大
        z-index: 2; // 避免被其他 li 遮挡
        transition: all 0.3s;
      }
    }
  }
  .content_item {
    margin-top: 4rem;
    .title {
      width: 100%;
      height: 1.5rem;
      padding-bottom: 1rem;
      background: url('../assets/img/appImg/title_bg.png') no-repeat left
        bottom/100% 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1.5rem;
      .title_l {
        margin-left: 4.5833rem;
        color: #333333;
        font-family: SourceHanSansCN-Bold;
        font-size: 1.1667rem;
        span {
          font-size: 0.8333rem;
          font-family: SourceHanSansCN-Normal;
          margin-left: 0.625rem;
        }
      }
      .title_r {
        color: #424451;
        font-size: 0.8333rem;
        text-decoration: underline;
      }
    }
    .activity_con {
      margin-top: 2rem;
      .activity_slide {
        .activity_item {
          overflow: hidden;
          position: relative;
          margin-left: 0.5rem;

          img {
            width: 100%;
            height: auto;
            position: relative;
          }

          .act_title {
            width: 100%;
            position: absolute;
            z-index: 5;
            bottom: 0;
            left: 0;
            height: 3.125rem;
            line-height: 3.125rem;
            width: 100%;
            padding: 0 0.75rem;
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px); /* 兼容Safari */
            background-color: rgba(0, 0, 0, 0.3); /* 半透明背景增强效果 */
            color: #fff;
            text-align: left;
            box-sizing: border-box;
            font-size: 1rem;

            &::before {
              position: absolute;
              top: 1.25rem;
              right: 1.25rem;
              content: '';
              display: inline-block;
              width: 0.3125rem;
              height: 0.3125rem;
              background: #fff;
              z-index: 6;
            }
          }
        }
      }
    }
    .news_con {
      .news_slide {
        .news_item {
          overflow: hidden;
          margin-left: 0.5rem;
          position: relative;
          height: 15.3333rem;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center; /* 图片的中心与容器的中心对齐 */
          }
          .new_title {
            position: absolute;
            left: 0;
            bottom: 0;
            height: 3.125rem;
            width: 100%;
            color: #fff;
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px); /* 兼容Safari */
            background-color: rgba(0, 0, 0, 0.3); /* 半透明背景增强效果 */
            .new_title_in {
              display: flex;
              align-items: center;
              justify-content: space-between;
              flex-direction: row;
              width: 100%;
              height: 3.125rem;
              .new_title_l {
                padding-left: 0.625rem;
                width: 75%;
                line-height: 3.125rem;
                box-sizing: border-box;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .swiper-paginationTwo {
                width: 25%;
                ::v-deep {
                  .swiper-pagination-bullet {
                    background: rgba(255, 255, 255, 0.5);
                    margin-left: 0.3125rem;
                  }
                }
              }
            }
          }
        }
      }
    }
    .news_con_d {
      margin-top: 2rem;
      height: 15rem;
      background: url('../assets/img/appImg/new_bg.png') no-repeat left
        bottom/100% 100%;
      .news_list {
        display: flex;
        height: 2.6667rem;
        align-items: center;
        .list_l {
          width: 30%;
          text-align: left;
          .day {
            color: #424451;
            font-size: 2rem;
          }
          .month {
            color: #424451;
            font-size: 1.1667rem;
            font-family: SourceHanSansCN-Light;
          }
        }
        .list_r {
          width: 70%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #424451;
          font-size: 1.1667rem;
        }
      }
      .more {
        width: 100%;
        text-align: center;
        color: #424451;
        font-size: 1rem;
        text-decoration: underline;
      }
    }
    .theme_con {
      margin-top: 2rem;
      width: 100%;
      height: 15.8333rem;
      // background: url('../assets/img/appImg/theme_bg.png') no-repeat left
      //   top/100% 100%;
      display: flex;
      justify-content: space-between;
      // padding: 2.75rem 1.5rem;
      padding: 0 1.5rem;
      .theme_con_img {
        width: 100%;
        height: 15.8333rem;
        img {
          width: 100%;
          height: 15.8333rem;
          object-fit: cover;
          object-position: center;
        }
      }
      .theme_con_l {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 2;
        .theme_title {
          color: #333333;
          font-size: 0.9167rem;
        }
        img {
          width: 8.6667rem;
          height: 5.0833rem;
          object-fit: cover;
          object-position: center; /* 图片的中心与容器的中心对齐 */
        }
        .theme_eng {
          color: #333333;
          font-size: 1.3333rem;
        }
      }
      .theme_con_r {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 3;
        .time {
          text-align: right;
          font-size: 1.3333rem;
        }
        .desc {
          text-align: right;
          color: #4d4d4d;
          font-size: 0.8333rem;
        }
      }
    }
    .activity_Time_con {
      .calendar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1.25rem;

        .calendarList {
          border: solid 1px #d9d9d9;
          border-radius: 0.625rem;
          padding: 0.625rem;
          .date {
            color: #424451;
            font-size: 1.25rem;
          }
          .week {
            color: #aaaaaa;
            font-size: 1.0833rem;
            font-family: SourceHanSansCN-Medium;
            text-align: center;
          }
          &.active {
            background: #424451;
            color: #fff;
            border: solid 1px #424451;
            .date {
              color: #fff;
            }
            .week {
              color: #fff;
            }
          }
        }
        .more {
          color: #777777;
          font-size: 0.8333rem;
          text-align: center;
          writing-mode: vertical-lr; /* 垂直方向，从左到右 */
        }
      }
      .activity_Time_list {
        .Time_list_top {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 2.4167rem;
          margin-bottom: 1.3333rem;
          .title_l {
            width: 4.6667rem;
            height: 2.4167rem;
            background: url('../assets/img/appImg/activity_time_title.png')
              no-repeat left center/100% 100%;
            padding: 0 0.1667rem;
            box-sizing: border-box;
            .title_l_in {
              .month {
                color: #333333;
                font-size: 1.1667rem;
              }
              .day {
                color: #333333;
                font-size: 2rem;
                font-family: SourceHanSansCN-Bold;
              }
            }
          }
          .title_r {
            height: 2.4167rem;
            font-size: 1.1667rem;
            color: #333;
            font-family: SourceHanSansCN-Medium;
            margin-top: 1.5rem;
            margin-left: 0.8333rem;
          }
        }
        .Time_list_down {
          margin-top: 2.1667rem;
          ul {
            li {
              width: 100%;
              display: flex;
              align-items: center;
              border-bottom: solid 0.0833rem #c2c2c2;
              height: 3rem;

              .time {
                width: 40%;
                text-align: center;
              }
              .name {
                width: 60%;
                text-align: left;
              }
            }
            li:nth-child(odd) {
              background-color: rgba(194, 194, 194, 0.16); /* 浅灰色 */
            }
          }
        }
      }
    }
    .presi_con {
      background: url('../assets/img/appImg/presi_bg.png') no-repeat center
        bottom/100% 13.4167rem;
      display: flex;
      flex-wrap: wrap;
      flex-wrap: wrap;
      gap: 3px; /* 设置间距 */
      justify-content: space-between;
      padding-bottom: 2.8333rem;
      .presi_character {
        width: calc((100% - 6px) / 3);
        height: 22.8333rem;
        margin-bottom: 0.25rem;
        .presi_img {
          width: 100%;
          height: 17.4167rem;
          border-radius: 0.3333rem 0.3333rem 0 0;
          overflow: hidden;
          img {
            width: 100%;
            height: 17.4167rem;
            object-fit: cover;
            object-position: center; /* 图片的中心与容器的中心对齐 */
          }
        }

        .presi_content {
          width: 100%;
          padding: 0.5rem 1rem;
          height: 5.4167rem;
          background: url('../assets/img/appImg/presi_content_bg.png') no-repeat
            left bottom/100% 100%;
          .presi_title {
            color: #fff;
            font-size: 1.1667rem;
            font-family: SourceHanSansCN-Medium;
            line-height: 2rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
          }
          .presi_actor {
            color: rgba(255, 255, 255, 0.6);
            font-size: 0.8333rem;
            line-height: 1.3333rem;
            height: 1.1667rem;
            text-align: center;
          }
        }
      }
      &::after {
        content: '';
        flex: auto;
        width: calc((100% - 6px) / 3);
        /* 或者使用固定宽度，与项目宽度相同 */
        /* width: 30%; */
      }
      .more {
        position: absolute;
        width: 100%;
        text-align: center;
        color: #424451;
        font-size: 1rem;
        text-decoration: underline;
        bottom: 1.4167rem;
      }
    }
    .video_con {
      .ThreeSwiper {
        // height: 15.3333rem;
        /* 强制所有 Slide 以底部为中心缩放 */
        .swiper-slide {
          transform-origin: center bottom !important;
        }

        /* 两侧缩小 + 微调 */
        .swiper-slide:not(.swiper-slide-active) {
          transform: scale(0.9) translateY(0px) !important;
        }

        /* 中间保持原样 */
        .swiper-slide-active {
          transform: scale(1) translateY(0) !important;
        }
      }
      .video_slide {
        .video_item {
          height: 15.3333rem;
          overflow: hidden;
          position: relative;
          margin-left: 0.5rem;
          .video_item_default {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center; /* 图片的中心与容器的中心对齐 */
          }

          .video_title {
            width: 100%;
            position: absolute;
            z-index: 5;
            bottom: 0;
            left: 0;
            height: 3.125rem;
            line-height: 3.125rem;
            width: 100%;
            padding: 0 0.75rem;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0.5) 100%
            ); /* 半透明背景增强效果 */
            color: #fff;
            text-align: left;
            box-sizing: border-box;
            font-size: 1rem;
          }
        }
      }
      .swiper-paginationThree {
        margin: 1rem auto;
        text-align: center;
        ::v-deep {
          .swiper-pagination-bullet {
            background: #c2c4ce;
            margin-left: 0.3125rem;
            border-radius: 0;
            width: 0.3333rem;
            height: 0.3333rem;
          }
          .swiper-pagination-bullet-active {
            background: #1d1d1d !important;
            transform: rotate(45deg); /* 旋转 + 放大 */
          }
        }
      }
      .play_con {
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 9999;
        transform: translate(-24px, -24px);
        // background: #000;
        cursor: pointer;
        img {
          width: 48px;
          height: 48px;
          opacity: 1;
        }
      }
      .swiper-slide-active {
        img {
          width: 48px;
          height: 48px;

          opacity: 1;
        }
      }
    }
    .link_con {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 0.25rem;
      .link_item {
        width: calc((100% - 16px) / 3);
        height: 3.6667rem;
        margin-bottom: 0.8333rem;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center; /* 图片的中心与容器的中心对齐 */
        }
      }
      &::after {
        content: '';
        flex: auto;
        width: calc((100% - 16px) / 3);
        /* 或者使用固定宽度，与项目宽度相同 */
        /* width: 30%; */
      }
    }
  }
}

.swiper-footer {
  margin-top: 2.5rem;
  float: left;
  .swiper-paginationOne {
    position: absolute;
    right: 0;
    bottom: 0;
    color: #6b6d7a;
    text-align: right;
    font-size: 1rem;
  }
  .swiper-scrollbar {
    width: 92%;
    position: absolute;
    left: 0;
    bottom: 0;
    height: 4px;
    background: rgba(218, 219, 223, 0.6);
    margin-bottom: 8px;
  }

  .swiper-pagination-fraction {
    font-size: 14px;
    color: #666;
  }
}
::v-deep {
  .swiper-scrollbar-drag {
    background: linear-gradient(90deg, #aae5ef 0%, #b1bbff 100%) !important;
  }
  .content_top {
    .el-empty {
      padding: 0.625rem 0;
      .el-empty__image {
        width: 40% !important;
      }
      .el-empty__description {
        font-size: 0.75rem !important;
      }
    }
  }
}
</style>
